import { render } from "./ScatterPlot.vue?vue&type=template&id=0c1dca51&scoped=true"
import script from "./ScatterPlot.vue?vue&type=script&lang=js"
export * from "./ScatterPlot.vue?vue&type=script&lang=js"

import "./ScatterPlot.vue?vue&type=style&index=0&id=0c1dca51&lang=scss&scoped=true"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1dca51"]])

export default __exports__